import Layout from '@/layout';
import routerView from "@/components/otherTpl/routerView";

// 客服
export default {
    path: '/customerService',
    component: Layout,
    redirect: '/customerService/scheme/index',
    alwaysShow: true,
    meta: {
        title: '客服',
        icon: 'menu_kf',
        modules: [17000]
    },
    children: [
        // 订单
        {
            path: 'scheme',
            redirect: '/customerService/scheme/index',
            component: routerView,
            meta: {
                title: '订单管理',
                modules: [17002]
            },
            children: [
                {
                    path: 'index',
                    name: 'SchemeList',
                    component: () => import('@/views/customerService/schemeList/index'),
                    meta: {
                        breadcrumb: false,
                        title: '订单管理',
                        icon: 'spot',
                        keepAlive: true,
                        modules: [17002]
                    }
                },
                //  订单详情
                {
                    path: 'menuDetails/:id',
                    name: 'menuDetails',
                    hidden: true,
                    component: () => import('@/views/customerService/schemeList/menuDetails'),
                    meta: {
                        title: '订单详情',
                        activeMenu: '/customerService/scheme/index',
                        modules: [17002]
                    }
                },
                {
                    path: 'csOrderDesignDetail',
                    name: 'CsOrderDesignDetail',
                    hidden: true,
                    component: () => import('@/views/customerService/schemeList/orderDesignDetail'),
                    meta: {
                        title: '订单方案详情',
                        activeMenu: '/customerService/scheme/index',
                        modules: [17002]
                    }
                }
            ]
        },
        // 方案管理
        {
            path: 'proManagements',
            redirect: '/customerService/proManagements/index',
            component: routerView,
            meta: {
                title: '方案管理',
                icon: 'spot',
                modules: [17003]
            },
            children: [
                {
                    path: 'index',
                    name: 'ProManagements',
                    component: () => import('@/views/customerService/proManagements/index'),
                    meta: {
                        breadcrumb: false,
                        title: '方案管理',
                        icon: 'spot',
                        keepAlive: true,
                        modules: [17003]
                    }
                },
                {
                    path: 'autoDispatch/:id',
                    name: 'AutoDispatch',
                    hidden: true,
                    component: () => import('@/views/customerService/proManagements/autoDispatch'),
                    meta: {
                        title: '方案调度',
                        activeMenu: '/customerService/proManagements/index',
                        modules: [17003]
                    }
                }
            ]
        },
        // 素材管理
        {
            path: 'maManagement',
            name: 'MaManagement',
            component: () => import('@/views/customerService/maManagement/index'),
            meta: {
                title: '素材管理',
                icon: 'spot',
                modules: [17013]
            }
        },
        // 执行结果
        {
            path: '/exeManagement',
            component: routerView,
            redirect: '/exeManagement/submitTaskUp',
            meta: {
                title: '执行结果',
                icon: 'spot',
                modules: [17015]
            },
            children: [
                // 提交上刊任务
                {
                    path: 'submitTaskUp',
                    name: 'SubmitTaskUp',
                    component: () => import('@/views/customerService/exeManagement/submitTaskUp/index'),
                    meta: {
                        title: '提交上刊任务',
                        keepAlive: true,
                        modules: [17016]
                    }
                },
                // 提交下刊任务
                {
                    path: 'submitTaskDown',
                    name: 'SubmitTaskDown',
                    component: () => import('@/views/customerService/exeManagement/submitTaskDown/index'),
                    meta: {
                        title: '提交下刊任务',
                        keepAlive: true,
                        modules: [17020]
                    }
                },
                // 提交刊中任务
                {
                    path: 'submitTaskMonitor',
                    name: 'SubmitTaskMonitor',
                    component: () => import('@/views/customerService/exeManagement/submitTaskMonitor/index'),
                    meta: {
                        title: '提交监测任务',
                        keepAlive: true,
                        modules: [17023]
                    }
                },
                // 提交补偿任务
                {
                    path: 'submitTaskCompensate',
                    name: 'SubmitTaskCompensate',
                    component: () => import('@/views/customerService/exeManagement/submitTaskCompensate/index'),
                    meta: {
                        title: '提交补偿任务',
                        keepAlive: true,
                        modules: [17022]
                    }
                },
                // 方案结果
                {
                    path: 'programmeResult',
                    redirect: '/exeManagement/programmeResult/programmeResultList',
                    component: routerView,
                    meta: {
                        title: '方案结果',
                        modules: [17021]
                    },
                    children: [
                        {
                            path: 'programmeResultList',
                            name: 'ProgrammeResultList',
                            component: () => import('@/views/customerService/exeManagement/programmeResult/index'),
                            meta: {
                                breadcrumb: false,
                                title: '方案结果',
                                keepAlive: false,
                                modules: [17021]
                            }
                        }
                    ]
                },
                // 方案报告
                {
                    path: 'designResult',
                    redirect: '/exeManagement/designResult/designResultList',
                    component: routerView,
                    meta: {
                        title: '方案报告',
                        modules: [17018]
                    },
                    children: [
                        {
                            path: 'designResultList',
                            name: 'DesignResultList',
                            component: () => import('@/views/customerService/exeManagement/designResult/index'),
                            meta: {
                                breadcrumb: false,
                                title: '方案报告',
                                keepAlive: true,
                                modules: [17018]
                            }
                        },
                        // 方案报告详情
                        {
                            path: 'designResultDetail/:id',
                            name: 'DesignResultDetail',
                            hidden: true,
                            component: () => import('@/views/customerService/exeManagement/designResult/designResultDetail'),
                            meta: {
                                title: '方案报告详情',
                                activeMenu: '/exeManagement/designResult/designResultList',
                                modules: [17018]
                            }
                        },
                        // 补偿方案
                        {
                            path: 'compensate/:id',
                            name: 'Compensate',
                            hidden: true,
                            component: () => import('@/views/customerService/exeManagement/designResult/compensate'),
                            meta: {
                                title: '补偿方案',
                                activeMenu: '/exeManagement/designResult/designResultList',
                                modules: [17018]
                            }
                        }
                    ]
                }
            ]
        },
        {
            path: 'metro',
            redirect: '/customerService/metro/metroManage/index',
            component: routerView,
            meta: {
                title: '地铁媒体',
                icon: 'spot',
                modules: [21023]
            },
            children: [
                {
                    path: 'dateManage',
                    name: 'MetroDateManage',
                    component: routerView,
                    meta: {
                        title: '发布期管理',
                        modules: [21024]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'MetroDateManageIndex',
                            component: () => import('@/views/customerService/metro/dateManage/index'),
                            meta: {
                                breadcrumb: false,
                                title: '发布期管理',
                                keepAlive: true,
                                modules: [21024]
                            }
                        },
                        // 发布期详细
                        {
                            path: 'detail/:id',
                            name: 'MetroDateManageDetail',
                            hidden: true,
                            component: () => import('@/views/customerService/metro/dateManage/detail'),
                            meta: {
                                title: '发布期详情',
                                activeMenu: '/customerService/metro/dateManage/index',
                                modules: [21024]
                            }
                        }
                    ]
                },
                // 地铁方案
                {
                    path: 'metroManage',
                    redirect: '/customerService/metro/metroManage/index',
                    component: routerView,
                    meta: {
                        title: '方案管理',
                        modules: [21025]
                    },
                    children: [
                        // 地铁方案-列表
                        {
                            path: 'index',
                            name: 'MetroManageIndex',
                            component: () => import('@/views/customerService/metro/metroManage/index'),
                            meta: {
                                breadcrumb: false,
                                title: '方案管理',
                                keepAlive: true,
                                modules: [21025]
                            }
                        }
                    ]
                },
                // 素材管理
                {
                    path: 'materialManage',
                    name: 'MetroMaManagement',
                    component: () => import('@/views/customerService/metro/materialManage/index'),
                    meta: {
                        title: '素材管理',
                        modules: [21026]
                    }
                },
                {
                    path: 'toolBox',
                    component: routerView,
                    redirect: '/customerService/metro/toolBox/index',
                    meta: {
                        title: '工具箱',
                        modules: [21027]
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'MetroCustomerToolBox',
                            component: () => import('@/views/customerService/metro/toolBox/index'),
                            meta: {
                                breadcrumb: false,
                                title: '工具箱',
                                modules: [21027]
                            }
                        },
                        {
                            path: 'putBag',
                            name: 'MetrPutBag',
                            hidden: true,
                            component: () => import('@/views/customerService/metro/toolBox/putBag'),
                            meta: {
                                title: '天摩投放包',
                                activeMenu: '/customerService/metro/toolBox/index',
                                modules: [21027]
                            }
                        },
                        {
                            path: 'taskup',
                            name: 'MetroTaskup',
                            hidden: true,
                            component: () => import('@/views/customerService/metro/toolBox/taskup'),
                            meta: {
                                title: '天摩上刊表',
                                activeMenu: '/customerService/metro/toolBox/index',
                                modules: [21027]
                            }
                        }
                    ]
                }
            ]
        },
        {
            path: 'toolBox',
            component: routerView,
            redirect: '/customerService/toolBox/index',
            meta: {
                title: '客服工具箱',
                icon: 'spot',
                modules: [17019]
            },
            children: [
                {
                    path: 'index',
                    name: 'CustomerToolBox',
                    component: () => import('@/views/customerService/toolBox/index'),
                    meta: {
                        breadcrumb: false,
                        title: '客服工具箱',
                        modules: [17019]
                    }
                },
                {
                    path: 'positionInfo',
                    name: 'PositionInfo',
                    hidden: true,
                    component: () => import('@/views/customerService/toolBox/positionInfo'),
                    meta: {
                        title: '版位情况',
                        keepAlive: true,
                        activeMenu: '/customerService/toolBox/index',
                        modules: [17116]
                    }
                },
                {
                    path: 'aiCheckPicture',
                    name: 'AiCheckPicture',
                    hidden: true,
                    component: () => import('@/views/customerService/toolBox/aiCheckPicture'),
                    meta: {
                        title: 'AI照片检查',
                        keepAlive: true,
                        activeMenu: '/customerService/toolBox/index',
                        modules: [17124]
                    }
                },
                {
                    path: 'taskupInfo',
                    name: 'TaskupInfo',
                    hidden: true,
                    component: () => import('@/views/customerService/toolBox/taskup'),
                    meta: {
                        title: '上刊情况明细',
                        keepAlive: true,
                        activeMenu: '/customerService/toolBox/index',
                        modules: [17118]
                    }
                },
                {
                    path: 'communityUp',
                    name: 'CommunityUp',
                    hidden: true,
                    component: () => import('@/views/customerService/toolBox/communityUp'),
                    meta: {
                        title: '社区上刊情况',
                        activeMenu: '/customerService/toolBox/index',
                        modules: [17121]
                    }
                },
                {
                    path: 'sparePosition',
                    name: 'SparePosition',
                    hidden: true,
                    component: () => import('@/views/customerService/toolBox/sparePosition'),
                    meta: {
                        title: '空余版位查询',
                        activeMenu: '/customerService/toolBox/index',
                        modules: [17112]
                    }
                },
                {
                    path: 'queryPosition',
                    name: 'QueryPosition',
                    hidden: true,
                    component: () => import('@/views/customerService/toolBox/queryPosition'),
                    meta: {
                        title: '版位在刊情况',
                        activeMenu: '/customerService/toolBox/index',
                        modules: [17119]
                    }
                },
                {
                    path: 'divideRemind',
                    name: 'DivideRemind',
                    hidden: true,
                    component: () => import('@/views/customerService/toolBox/divideRemind'),
                    meta: {
                        title: '方案分成到期提醒',
                        activeMenu: '/customerService/toolBox/index',
                        modules: [17120]
                    }
                },
                {
                    path: 'exportSpecial',
                    name: 'ExportSpecial',
                    hidden: true,
                    component: () => import('@/views/customerService/toolBox/exportSpecial'),
                    meta: {
                        title: '导出特发',
                        activeMenu: '/customerService/toolBox/index',
                        modules: [17114]
                    }
                },
                {
                    path: 'queryProject',
                    name: 'QueryProject',
                    hidden: true,
                    component: () => import('@/views/customerService/toolBox/queryProject'),
                    meta: {
                        title: '方案查询',
                        activeMenu: '/customerService/toolBox/index',
                        modules: [17113]
                    }
                },
                {
                    path: 'exportUp',
                    name: 'ExportUp',
                    hidden: true,
                    component: () => import('@/views/customerService/toolBox/exportUp'),
                    meta: {
                        title: '导出上刊率',
                        activeMenu: '/customerService/toolBox/index',
                        modules: [17117]
                    }
                },
                {
                    path: 'contractAdjust',
                    name: 'ContractAdjust',
                    hidden: true,
                    component: () => import('@/views/customerService/toolBox/contractAdjust'),
                    meta: {
                        title: '合约调整',
                        activeMenu: '/customerService/toolBox/index',
                        modules: [17110]
                    }
                },
                {
                    path: 'dueRemind',
                    name: 'DueRemind',
                    hidden: true,
                    component: () => import('@/views/customerService/toolBox/dueRemind'),
                    meta: {
                        title: '方案到期提醒',
                        activeMenu: '/customerService/toolBox/index',
                        modules: [17115]
                    }
                },
                {
                    path: 'csMap',
                    name: 'csMap',
                    hidden: true,
                    component: () => import('@/views/customerService/toolBox/csMap/index'),
                    meta: {
                        title: '地图',
                        icon: 'spot',
                        modules: [17109],
                        activeMenu: '/customerService/toolBox/index'
                    }
                },
                // 大方案
                {
                    path: 'bigPlan',
                    redirect: '/customerService/toolBox/bigPlan/bigPlanList',
                    component: routerView,
                    hidden: true,
                    meta: {
                        title: '大方案',
                        icon: 'spot',
                        modules: [17111],
                        activeMenu: '/customerService/toolBox/index'
                    },
                    children: [
                        {
                            path: 'bigPlanList',
                            name: 'BigPlanList',
                            hidden: true,
                            component: () => import('@/views/customerService/toolBox/bigPlan/index'),
                            meta: {
                                breadcrumb: false,
                                title: '大方案',
                                icon: 'spot',
                                activeMenu: '/customerService/toolBox/index',
                                modules: [17111]
                            }
                        },
                        // 大方案详情
                        {
                            path: 'bigPlanDetail/:id',
                            name: 'BigPlanDetail',
                            hidden: true,
                            component: () => import('@/views/customerService/toolBox/bigPlan/detail'),
                            meta: {
                                title: '大方案详情',
                                icon: 'spot',
                                activeMenu: '/customerService/toolBox/index',
                                modules: [17111]
                            }
                        }
                    ]
                },
                {
                    path: 'updatePhotoTime',
                    name: 'UpdatePhotoTime',
                    hidden: true,
                    component: () => import('@/views/customerService/toolBox/updatePhotoTime'),
                    meta: {
                        title: '拍照时间调整',
                        activeMenu: '/customerService/toolBox/index',
                        modules: [17122]
                    }
                },
                // 发布期管理
                {
                    path: 'releManagement',
                    redirect: '/customerService/toolBox/releManagement/releManagementList',
                    component: routerView,
                    hidden: true,
                    meta: {
                        title: '发布期管理',
                        icon: 'spot',
                        activeMenu: '/customerService/toolBox/index',
                        modules: [17105]
                    },
                    children: [
                        {
                            path: 'releManagementList',
                            name: 'ReleManagementList',
                            hidden: true,
                            component: () => import('@/views/customerService/toolBox/releManagement/index'),
                            meta: {
                                breadcrumb: false,
                                title: '发布期管理',
                                icon: 'spot',
                                activeMenu: '/customerService/toolBox/index',
                                keepAlive: true,
                                modules: [17105]
                            }
                        },
                        // 发布期详细
                        {
                            path: 'releDetails/:id',
                            name: 'ReleDetails',
                            hidden: true,
                            component: () => import('@/views/customerService/toolBox/releManagement/detail'),
                            meta: {
                                title: '发布期详情',
                                activeMenu: '/customerService/toolBox/index',
                                modules: [17105]
                            }
                        }
                    ]
                },
                {
                    path: 'communityManagement',
                    redirect: '/customerService/toolBox/communityManagement/communityManagementList',
                    component: routerView,
                    hidden: true,
                    meta: {
                        title: '社区管理',
                        modules: [17106],
                        activeMenu: '/customerService/toolBox/index'
                    },
                    children: [
                        //  社区管理
                        {
                            path: 'communityManagementList',
                            name: 'CommunityManagementList',
                            hidden: true,
                            component: () => import('@/views/customerService/toolBox/resouManagement/communityManagement/index'),
                            meta: {
                                breadcrumb: false,
                                title: '社区管理',
                                modules: [17106],
                                activeMenu: '/customerService/toolBox/index',
                                keepAlive: true
                            }
                        },
                        //   社区管理详情
                        {
                            path: 'communityManDetails/:id',
                            name: 'CommunityManDetails',
                            hidden: true,
                            component: () => import('@/views/customerService/toolBox/resouManagement/communityManagement/communityManDetails'),
                            meta: {
                                title: '社区管理详情',
                                activeMenu: '/customerService/toolBox/index',
                                modules: [17106]
                            }
                        },
                        {
                            path: 'resourceDetail/:id',
                            name: 'CResourceDetail',
                            hidden: true,
                            component: () => import('@/views/customerService/toolBox/resouManagement/communityManagement/resourceDetail'),
                            meta: {
                                title: '资源详情',
                                activeMenu: '/customerService/toolBox/index',
                                modules: [17106]
                            }
                        },
                        //  查看占用
                        {
                            path: 'queryPlan',
                            name: 'queryPlan',
                            component: () => import('@/views/customerService/toolBox/resouManagement/communityManagement/queryPlan'),
                            hidden: true,
                            meta: {
                                title: '查看占用',
                                activeMenu: '/customerService/toolBox/index',
                                modules: [17106]
                            }
                        }
                    ]
                },
                //   维护管理
                {
                    path: 'maintenanceManagement',
                    redirect: '/customerService/toolBox/maintenanceManagement/maintenanceManagementList',
                    component: routerView,
                    hidden: true,
                    meta: {
                        title: '维护管理',
                        modules: [17107],
                        activeMenu: '/customerService/toolBox/index'
                    },
                    children: [
                        //   维护管理
                        {
                            path: 'maintenanceManagementList',
                            name: 'MaintenanceManagementList',
                            hidden: true,
                            component: () => import('@/views/customerService/toolBox/resouManagement/maintenanceManagement/index'),
                            meta: {
                                breadcrumb: false,
                                keepAlive: true,
                                title: '维护管理',
                                modules: [17107],
                                activeMenu: '/customerService/toolBox/index'
                            }
                        },
                        //   社区维护详情
                        {
                            path: 'maintenanceManDetails',
                            name: 'MaintenanceManDetails',
                            hidden: true,
                            component: () => import('@/views/customerService/toolBox/resouManagement/maintenanceManagement/maintenanceManDetails'),
                            meta: {
                                title: '社区维护详情',
                                activeMenu: '/customerService/toolBox/index',
                                modules: [17107]
                            }
                        }
                    ]
                },
                //   赠送管理
                {
                    path: 'presentManagement',
                    redirect: '/customerService/toolBox/presentManagement/presentManagementList',
                    component: routerView,
                    hidden: true,
                    meta: {
                        title: '赠送管理',
                        modules: [17108],
                        activeMenu: '/customerService/toolBox/index'
                    },
                    children: [
                        //   赠送管理
                        {
                            path: 'presentManagementList',
                            name: 'PresentManagementList',
                            component: () => import('@/views/customerService/toolBox/resouManagement/presentManagement/index'),
                            hidden: true,
                            meta: {
                                breadcrumb: false,
                                title: '赠送管理',
                                modules: [17108],
                                activeMenu: '/customerService/toolBox/index'
                            }
                        },
                        //   赠送详情
                        {
                            path: 'presentDetails',
                            name: 'PresentDetails',
                            component: () => import('@/views/customerService/toolBox/resouManagement/presentManagement/presentDetails'),
                            hidden: true,
                            meta: {
                                title: '赠送详情',
                                activeMenu: '/customerService/toolBox/index',
                                modules: [17108]
                            }
                        }
                    ]
                }
            ]
        }
    ]
};
